import React, { useEffect, useState } from "react";
import { FaLock, FaEnvelope, FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { loginSuccess, logoutSuccess } from "../redux-toolkit/slices/authSlice";
import { fingerprintVerifySuccess } from "../redux-toolkit/slices/fingerPrintSlice";
import presidentImgae from "../assets/images/Adv Rajeev Sharma.jpg";
import secretary from "../assets/images/Adv. Ajay Bist3.jpg";
import president from "../assets/images/president.png";
import { clearImageData } from "../redux-toolkit/slices/imageSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import barLogo from "../assets/images/BarAssociationDeharadunLogo.png";
import hammer from "../assets/images/Hammer.png";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import axios from "axios";
import { toast } from "react-toastify";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBBtn,
  MDBValidationItem,
  MDBCardText,
  MDBCardImage,
} from "mdb-react-ui-kit";
import "../styles/login.css";
import Modal from "react-bootstrap/Modal";
import dummyFingerPrint from "../assets/images/dummyFingerPrint.jpg";
import Image from "react-bootstrap/Image";
import fingerPrintServices from "../utilities/demo";
import Loader from "../components/Loader";
import axiosInstance from "../utilities/apiConfig";
import validateTemplateBase64Data from "../utilities/validateTemplateBase64Data";
import ScannerLoader from "../components/ScannerLoader";
import fingerpirntgif from "../assets/images/scannerLoading.gif";
const Login = () => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [template2, setTemplate2] = useState("");
  const [imageSrc2, setImageSrc2] = useState("");
  const [secugenLic, setSecugenLic] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [fingerPrintDB, setFingerPrintDB] = useState(false);
  const [fingerPrintLogin, setFingerPrintLogin] = useState(false);
  const [fingPrintLoginImage, setFingerPrintLoginImage] = useState("");
  const [isFingerPrintScannerinProgress, setIsFingerPrintScannerinProgress] =
    useState(false);
  const [refresh, setRefresh] = useState(0);
  const [loginFormData, setLoginFormData] = useState({
    email: "",
    password: "",
  });

  // Call the fingerPrintService to get the object containing the functions
  const fingerPrintService = fingerPrintServices();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userDeatils = useSelector((state) => state.auth?.userData?.authUser);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginFormData({
      ...loginFormData,
      [name]: value,
    });
  };

  const validateForm = () => {
    let isValid = true;
    if (!loginFormData.email) {
      toast.error("Email is required");
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(loginFormData.email)) {
      toast.error("Email address is invalid");
      isValid = false;
    }
    if (!loginFormData.password) {
      toast.error("Password is required");
      isValid = false;
    }
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    debugger;

    if (validateForm()) {
      setLoading(true);
      dispatch(logoutSuccess());
      try {
        const response = await axiosInstance.post(
          `/LoginFees/login_user`,
          loginFormData
        );

        //debugger;
        console.log("Login Success Data", response.data);

        if (response.data.statusCode === 200) {
          //setShowModal(true);
          dispatch(loginSuccess(response.data));
          setFingerPrintDB(response.data.authUser?.fingerprintData);
          // callSGIFPGetData();
          setRefresh(refresh + 1);
        } else {
          // Handle other success status codes if needed
          // For example, status code 404 may indicate user not registered
          toast.error(response.data.status);
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("An error occurred. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
  };

  const successFunc2 = (result) => {
    setIsFingerPrintScannerinProgress(false);
    if (
      result.ErrorCode === 0 &&
      result != null &&
      result.BMPBase64.length > 0
    ) {
      setTemplate2(result.TemplateBase64);
      setImageSrc2(result.BMPBase64);

      console.log("Finger Print Data", result.TemplateBase64);
      setFingerPrintLogin(result.TemplateBase64);
      console.log("Finger Print Image", result.BMPBase64);
      setFingerPrintLoginImage("data:image/bmp;base64," + result.BMPBase64);
      console.log(fingerPrintDB);
      handleVerifyFingerPrint(result.TemplateBase64, fingerPrintDB);
    } else {
      if (result.ErrorCode === 3) {
        toast.error("Please check your fingerprint device");
      } else if (result.ErrorCode === 54) {
        toast("Timeout, scan your finger again");
      } else {
        toast.error("Please scan your finger again");
      }
    }
  };

  // Error callback function
  const errorFunc = (status) => {
    setIsFingerPrintScannerinProgress(false);
    toast.error("Please Check Secugen fingerprit service is working properly");
    // toast.error(`Check if SGIBIOSRV is running; status = ${status}:`);
  };

  const callSGIFPGetData = () => {
    setIsFingerPrintScannerinProgress(true);
    console.log("a1");
    const uri = "https://localhost:8000/SGIFPCapture";
    console.log("a2");
    const params = new URLSearchParams({
      Timeout: 10000,
      Quality: 50,
      licstr: secugenLic,
      templateFormat: "ISO",
    });

    axios
      .post(uri, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        successFunc2(response.data);
      })
      .catch((error) => {
        errorFunc(error);
      });
  };

  const handleVerifyFingerPrint = async (
    fingerprintFromLogin,
    fingerpintDatabase
  ) => {
    try {
      //debugger;
      setLoading(true);
      const condition1 = validateTemplateBase64Data(fingerpintDatabase);
      const condition2 = validateTemplateBase64Data(fingerprintFromLogin);
      console.log(condition1);
      if (condition1 && condition2) {
        const response = await fingerPrintService.matchFingerPrint(
          fingerpintDatabase,
          fingerprintFromLogin,
          fingerPrintService.succMatch,
          fingerPrintService.failureFunc
        );
        console.log("Response of Matching:", response);
        if (response.matched) {
          dispatch(clearImageData());
          //debugger;
          if (userDeatils?.role === "Super Admin") {
            navigate("/Dashboard");
          } else if (userDeatils?.role === "Cashier") {
            navigate("/Accounts");
          } else if (userDeatils?.role === "Accountant") {
            navigate("/Fees");
          } else if (userDeatils?.role === "Computer Operator") {
            navigate("/Verification");
          } else if (userDeatils?.role === "Election") {
            navigate("/Voting");
          } else {
            navigate("/");
          }

          dispatch(fingerprintVerifySuccess());
          toast.success("FingerPrint Verified");
        } else {
          toast.error("FingerPrint Not Matched");
        }
      } else {
        toast.error("Please scan your fingerprint again");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error : Finger Data Not Verified");
      // Handle the error here
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // useEffect(() => {
  //   console.log(fingerPrintDB);
  // }, [refresh])

  // Step 3: Effect hook to call the function when fingerprint data is updated
  useEffect(() => {
    if (fingerPrintDB) {
      callSGIFPGetData();
    }
  }, [fingerPrintDB, refresh]);

  return (
    <>
      {loading && <Loader />}
      {isFingerPrintScannerinProgress && <ScannerLoader />}

      <section id="LoginPage">
        <MDBContainer className="py-5">
          <MDBRow className="d-flex justify-content-center align-items-center h-100">
            <MDBCol xl="11" xxl={10}>
              <MDBCard className="rounded-3 text-black">
                <MDBRow className="g-0">
                  <MDBCol
                    lg="5"
                    className="d-flex align-items-center justify-content-center"
                    id="login_left_side"
                  >
                    <div className="row justify-content-center align-items-center w-100">
                      <div className="col-sm-6 my-auto text-center w-100">
                        <div className="logo_wrapper my-auto">
                          <img src={barLogo} className="image--cover" />
                        </div>
                        <div className="bar_logo_name">
                          Bar Association Dehradun
                        </div>
                      </div>
                    </div>
                  </MDBCol>

                  <MDBCol lg="7">
                    <MDBCardBody className="p-md-5 mx-md-4">
                      <div className="d-flex justify-content-around">
                        <div className="col-6 px-1">
                          <div>
                            <img
                              id="president"
                              src={president}
                              className="img-fluid"
                              alt=""
                              style={{
                                border: "5px solid black",
                                borderRadius: "10px",
                                padding: "10px",
                                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
                              }}
                            />
                          </div>
                          <div className="text-center">
                            Sh. Anil Kukreti 
                          </div>
                          <p className="text-center">(President)</p>
                        </div>

                        <div className="col-6 px-1">
                          <div>
                            <img
                              id="secretary"
                              src={secretary}
                              className="img-fluid"
                              alt=""
                              style={{
                                border: "5px solid black",
                                borderRadius: "10px",
                                padding: "10px",
                                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
                              }}
                            />
                          </div>
                          <div className="text-center">Sh. Ajay Bist</div>
                          <p className="text-center">(Secretary)</p>
                        </div>
                      </div>

                      <form>
                        <h4 className="my-5 pb-1 text-center">Login</h4>

                        <div className="form-outline mb-4">
                          <div style={{ position: "relative" }}>
                            <div
                              style={{
                                position: "absolute",
                                left: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                              }}
                            >
                              <FaEnvelope />
                              &nbsp;|
                            </div>
                            <input
                              type={"text"}
                              name="email"
                              value={loginFormData.email}
                              onChange={(e) => handleChange(e)}
                              className="form-control"
                              placeholder="Email"
                              style={{
                                paddingLeft: "40px",
                                paddingRight: "40px",
                                borderBottom: "2px solid #ccc",
                                borderRadius: "0px",
                                color: "black",
                                opacity: "1",
                              }}
                            />
                          </div>
                        </div>

                        <div className="form-outline mb-4">
                          <div style={{ position: "relative" }}>
                            <div
                              style={{
                                position: "absolute",
                                left: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                              }}
                            >
                              <FaLock />
                              &nbsp;|
                            </div>
                            <input
                              type={showPassword ? "text" : "password"}
                              name="password"
                              value={loginFormData.password}
                              onChange={(e) => handleChange(e)}
                              className="form-control"
                              placeholder="Password"
                              style={{
                                paddingLeft: "40px",
                                paddingRight: "40px",
                                borderBottom: "2px solid #ccc",
                                borderRadius: "0px",
                                color: "black",
                              }}
                            />
                            {showPassword ? (
                              <FaRegEye
                                onClick={togglePasswordVisibility}
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                }}
                              />
                            ) : (
                              <FaRegEyeSlash
                                onClick={togglePasswordVisibility}
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <a className=" text-end text-danger" href="#!">
                            Forgot password?
                          </a>
                        </div>

                        <div className="text-center mt-2 pt-1 mb-5 pb-1">
                          <MDBBtn
                            className="btn btn-block fa-lg gradient-custom-1 mb-3"
                            type="button"
                            onClick={(e) => {
                              handleSubmit(e);
                            }} //handleSubmit(e)
                          >
                            Log in
                          </MDBBtn>
                          <div className="d-flex justify-content-center">
                            <a
                              className=" text-end text-primary"
                              href="/Registration"
                            >
                              Apply Registration
                            </a>{" "}
                            &nbsp; | &nbsp;
                            <a
                              className=" text-end text-danger"
                              href="/RegistrationStatus"
                            >
                              Check Status
                            </a>
                          </div>
                        </div>
                      </form>
                    </MDBCardBody>
                  </MDBCol>
                </MDBRow>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>
    </>
  );
};

export default Login;
